import { Controller } from "@hotwired/stimulus"

// Drives accepts_nested_attributes_for forms (Order line items, etc.):
//   - "Remove" hides an existing row by flipping its _destroy hidden
//     input to "1" (so Rails marks the join for deletion on save), or
//     just removes a brand-new row from the DOM if it has no
//     _destroy input yet.
//   - "Add" clones a fresh row from the data-nested-fields-fields-value
//     blob (rendered by the link_to_add_fields helper) and appends it
//     to the container identified by data-nested-fields-container-id.
//
// Previously this lived in an inline <script nonce> block under
// app/views/orders/_form.html.erb. Turbo Drive swaps page bodies but
// not CSP headers, so the per-page nonce stops matching after the
// first navigation and the browser refuses to execute the inline
// script. With the click handler never bound, the Remove button
// looked broken. Moving the logic into a Stimulus controller fixes
// that — controllers live in the application.js bundle which loads
// once with the correct CSP scope.
//
// HTML:
//   <div data-controller="nested-fields">
//     <div id="order_items">
//       <%= f.fields_for :order_items do |item_f| %>
//         <div class="nested-fields">
//           ...
//           <a href="#" data-action="click->nested-fields#remove">Remove</a>
//         </div>
//       <% end %>
//     </div>
//     <%= link_to_add_fields "+ Add Item", f, :order_items,
//           data: { action: "click->nested-fields#add" } %>
//   </div>
export default class extends Controller {
  remove(event) {
    event.preventDefault()
    const field = event.target.closest(".nested-fields")
    if (!field) return

    const destroyInput = field.querySelector('input[name*="_destroy"]')
    if (destroyInput) {
      destroyInput.value = "1"
      field.style.display = "none"
    } else {
      field.remove()
    }
  }

  add(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const time = new Date().getTime()
    const regexp = new RegExp(btn.dataset.id, "g")
    const content = btn.dataset.fields.replace(regexp, time)

    // The link_to_add_fields helper hard-codes #order_items as the
    // container today. If we add more nested-fields forms (suppliers,
    // shipments, etc.) we'd parameterize this — for now the order form
    // is the only caller.
    const container = document.getElementById("order_items")
    if (container) container.insertAdjacentHTML("beforeend", content)
  }
}
